<template>
  <div @contextmenu.prevent>
    <v-dialog v-model="dialog" fullscreen hide-overlay persistent>
      <v-card class="pdf-container" color="#424242">
        <v-toolbar flat color="#212121" dark>
          <v-toolbar-title>PDF Viewer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="zoomIn"><v-icon>mdi-magnify-plus</v-icon></v-btn>
          <v-btn icon @click="zoomOut"><v-icon>mdi-magnify-minus</v-icon></v-btn>
          <v-btn icon @click="closeViewer"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="scrollable-pdf" @contextmenu.prevent>
          <div ref="pdfContainer"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'PdfPopupViewer',
  props: ['url'],
  data () {
    return {
      dialog: false,
      pdfRef: null,
      totalPages: 0,
      scale: 1.5
    }
  },
  watch: {
    url: {
      immediate: true,
      handler (val) {
        if (val) {
          this.dialog = true
          setTimeout(() => this.loadPdf(), 300)
        }
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.blockPrint)

    if (!window.pdfjsLoaded) {
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.min.js'
      script.onload = () => {
        window.pdfjsLoaded = true
        if (this.url) {
          this.dialog = true
          setTimeout(() => this.loadPdf(), 300)
        }
      }
      document.body.appendChild(script)
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.blockPrint)
  },
  methods: {
    blockPrint (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault()
      }
    },
    async loadPdf () {
      const pdfjsLib = window['pdfjs-dist/build/pdf']
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.worker.min.js'

      const loadingTask = pdfjsLib.getDocument(this.url)
      const pdf = await loadingTask.promise
      this.pdfRef = pdf
      this.totalPages = pdf.numPages

      await this.renderAllPages()
    },
    async renderAllPages () {
      const container = this.$refs.pdfContainer
      container.innerHTML = ''

      for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
        const pageWrapper = document.createElement('div')
        container.appendChild(pageWrapper)
        await this.renderPage(pageNum, pageWrapper)
      }
    },
    async renderPage (pageNum, wrapper) {
      const page = await this.pdfRef.getPage(pageNum)
      const viewport = page.getViewport({ scale: this.scale })

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width
      canvas.style.marginBottom = '20px'
      canvas.style.display = 'block'

      const renderContext = {
        canvasContext: context,
        viewport: viewport
      }

      await page.render(renderContext).promise
      wrapper.appendChild(canvas)
    },
    zoomIn () {
      this.scale += 0.25
      this.renderAllPages()
    },
    zoomOut () {
      if (this.scale > 0.5) {
        this.scale -= 0.25
        this.renderAllPages()
      }
    },
    closeViewer () {
      this.dialog = false
      this.url = ''
      this.pdfRef = null
      this.totalPages = 0
      this.scale = 1.5
      this.$refs.pdfContainer.innerHTML = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.pdf-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.scrollable-pdf {
  overflow-y: auto;
  padding: 16px;
  flex-grow: 1;
  background-color: #9e9e9e;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media print {
  body * {
    display: none !important;
  }
}
</style>
